import { FC, ReactNode } from 'react';

import * as ST from './styled';

interface IProps {
    id?: string,
    className?: string,
}

interface IPageSection extends FC<IProps> {
    Title: typeof ST.SectionTitle,
    Content: typeof ST.SectionContent,
    Button: typeof ST.SectionButton,
    children?: ReactNode,
}

const PageSection: IPageSection = ({ id = '', className, children }) => {
    return (
        <ST.PageSection id={id} className={className}>
            {children}
        </ST.PageSection>
    );
};

PageSection.Title = ST.SectionTitle;
PageSection.Content = ST.SectionContent;
PageSection.Button = ST.SectionButton;

export default PageSection;
